// import React, { useEffect } from "react";

// const AdSenseAd = ({ client, slot, format = "auto", responsive = "true" }) => {
//   useEffect(() => {
//     try {
//       (window.adsbygoogle = window.adsbygoogle || []).push({});
//     } catch (e) {
//       console.error("AdSense error", e);
//     }
//   }, []);

//   return (
//     <ins
//       className="adsbygoogle"
//       style={{ display: "block", margin: "20px 0", textAlign: "center" }}
//       data-ad-client={client}
//       data-ad-slot={slot}
//       data-ad-format={format}
//       data-full-width-responsive={responsive}
//     ></ins>
//   );
// };

// export default AdSenseAd;



// import React, { useEffect } from "react";

// const AdManagerAd = ({ adUnit, size, divId }) => {
//   useEffect(() => {
//     if (!window.googletag) {
//       window.googletag = { cmd: [] };
//     }

//     window.googletag.cmd.push(() => {
//       // Prevent duplicate slot creation
//       if (!window.googletag.pubads().getSlots().find(s => s.getSlotElementId() === divId)) {
//         window.googletag
//           .defineSlot(adUnit, size, divId)
//           .addService(window.googletag.pubads());

//         window.googletag.pubads().enableSingleRequest();
//         window.googletag.enableServices();
//       }

//       window.googletag.display(divId);
//     });
//   }, [adUnit, size, divId]);

//   return (
//     <div
//       id={divId}
//       style={{ minWidth: size[0], minHeight: size[1], margin: "20px auto" }}
//     />
//   );
// };

// export default AdManagerAd;

// import { useEffect } from "react";

// const AdManagerAd = ({ adUnit, size, divId }) => {
//   useEffect(() => {
//     if (!window.googletag) {
//       window.googletag = { cmd: [] };
//     }

//     window.googletag.cmd.push(() => {
//       const existingSlot = window.googletag
//         .pubads()
//         .getSlots()
//         .find((slot) => slot.getSlotElementId() === divId);

//       // ✅ Prevent duplicate slots
//       if (!existingSlot) {
//         window.googletag
//           .defineSlot(adUnit, size, divId)
//           .addService(window.googletag.pubads());

//         window.googletag.pubads().enableSingleRequest();
//         window.googletag.enableServices();
//       }

//       window.googletag.display(divId);
//     });
//   }, [adUnit, size, divId]);

//   return (
//     <div
//       id={divId}
//       style={{
//         minWidth: size[0],
//         minHeight: size[1],
//       }}
//     />
//   );
// };

// export default AdManagerAd;

// import { useEffect } from "react";

// let gptInitialized = false;

// const AdManagerAd = ({ adUnit, size, divId, sizeMapping }) => {
//   useEffect(() => {
//     // Load GPT if not present
//     if (!window.googletag) {
//       window.googletag = { cmd: [] };
//     }

//     window.googletag.cmd.push(() => {
//       const pubads = window.googletag.pubads();

//       // ✅ Check if slot already exists
//       const existingSlot = pubads
//         .getSlots()
//         .find((slot) => slot.getSlotElementId() === divId);

//       if (!existingSlot) {
//         let slot = window.googletag
//           .defineSlot(adUnit, size, divId)
//           .addService(pubads);

//         // ✅ Apply responsive size mapping
//         if (sizeMapping) {
//           const mapping = window.googletag.sizeMapping();

//           sizeMapping.forEach((map) => {
//             mapping.addSize(map.viewport, map.sizes);
//           });

//           slot.defineSizeMapping(mapping.build());
//         }
//       }

//       // ✅ Initialize GPT only once
//       if (!gptInitialized) {
//         pubads.enableSingleRequest();

//         pubads.enableLazyLoad({
//           fetchMarginPercent: 100,
//           renderMarginPercent: 50,
//           mobileScaling: 2.0,
//         });

//         window.googletag.enableServices();
//         gptInitialized = true;
//       }

//       // ✅ Display ad
//       window.googletag.display(divId);
//     });
//   }, [adUnit, size, divId, sizeMapping]);

//   return (
//     <div
//       id={divId}
//       style={{
//         width: "100%",
//         textAlign: "center",
//         margin: "0 auto",
//       }}
//     />
//   );
// };

// export default AdManagerAd;

import { useEffect } from "react";

let gptInitialized = false;

const AdManagerAd = ({ adUnit, size, divId, sizeMapping }) => {
  useEffect(() => {
    if (!window.googletag) {
      window.googletag = { cmd: [] };
    }

    let slot;

    window.googletag.cmd.push(() => {
      const pubads = window.googletag.pubads();

      // ✅ Avoid duplicate slot
      const existingSlot = pubads
        .getSlots()
        .find((s) => s.getSlotElementId() === divId);

      if (!existingSlot) {
        slot = window.googletag
          .defineSlot(adUnit, size, divId)
          .addService(pubads);

        // ✅ Responsive size mapping
        if (sizeMapping) {
          const mapping = window.googletag.sizeMapping();

          sizeMapping.forEach((map) => {
            mapping.addSize(map.viewport, map.sizes);
          });

          slot.defineSizeMapping(mapping.build());
        }
      }

      // ✅ Init GPT only once
      if (!gptInitialized) {
        pubads.enableSingleRequest();

        pubads.enableLazyLoad({
          fetchMarginPercent: 100,
          renderMarginPercent: 50,
          mobileScaling: 2.0,
        });

        window.googletag.enableServices();
        gptInitialized = true;
      }

      window.googletag.display(divId);
    });

    // ✅ CLEANUP (VERY IMPORTANT)
    return () => {
      window.googletag.cmd.push(() => {
        const pubads = window.googletag.pubads();
        const slots = pubads.getSlots();

        const targetSlot = slots.find(
          (s) => s.getSlotElementId() === divId
        );

        if (targetSlot) {
          window.googletag.destroySlots([targetSlot]);
        }
      });
    };
  }, [adUnit, size, divId, sizeMapping]);

  return (
    <div
      id={divId}
      style={{
        width: "100%",
        textAlign: "center",
        margin: "0 auto",
      }}
    />
  );
};

export default AdManagerAd;